import memoizeOne from 'memoize-one';

import { OptionType } from 'interfaces';
import {
  AgencyStatus,
  SalesChannelLegacyStatus,
  Territory,
} from 'interfaces/generated.types';

export interface ISalesChannelValues {
  agency: OptionType | null;
  allAgencies: OptionType[];
  id: string;
  altId?: number;
  name: string;
  journey: string;
  owner: OptionType | null;
  status?: SalesChannelLegacyStatus;
  territory?: Territory;
}

export const salesChannelStatusValues = [
  {
    value: SalesChannelLegacyStatus.Draft,
    label: 'Draft',
    isDisabled: (value: SalesChannelLegacyStatus) =>
      [SalesChannelLegacyStatus.Active, SalesChannelLegacyStatus.Inactive].includes(value),
  },
  {
    value: SalesChannelLegacyStatus.Active,
    label: 'Active',
    isDisabled: (value: SalesChannelLegacyStatus) =>
      [SalesChannelLegacyStatus.Draft].includes(value),
  },
  {
    value: SalesChannelLegacyStatus.Inactive,
    label: 'Inactive',
    isDisabled: (value: SalesChannelLegacyStatus) =>
      [SalesChannelLegacyStatus.Draft].includes(value),
  },
];

export const getSalesChannelStatusData = memoizeOne(
  (values: ISalesChannelValues, agencyStatus: AgencyStatus) => [
    {
      status: SalesChannelLegacyStatus.Draft,
      required: [...(!values.name ? ["Complete 'Name'"] : [])],
    },
    {
      status:
        values.status === SalesChannelLegacyStatus.Inactive
          ? SalesChannelLegacyStatus.Inactive
          : SalesChannelLegacyStatus.Active,
      required: [
        ...(!values.name ? ["Waiting for 'Name'"] : []),
        ...(agencyStatus !== AgencyStatus.Enabled
          ? ['Waiting for Agency to be in ENABLED state']
          : []),
      ],
    },
  ]
);

export const salesChannelDetailsFields = [
  'agency',
  'name',
  'owner',
  'territory',
];
